<script>
  import {
    y,
    hideLabels,
    showModal,
    posBeforeBuy,
    showLabelPage,
    showSpecimenPage,
  } from '../stores.js'
  import { BUY } from '../data/sections.js'
  import BuyButton from './BuyButton.svelte'
  import Header from './header.svelte'
  import Popup from './popup.svelte'

  import { createEventDispatcher } from 'svelte'
  let dispatch = createEventDispatcher()
  let close = () => dispatch('close')
  let closeLabels = () => dispatch('closeLabels')
  let closeSpecimens = () => dispatch('closeSpecimens')

  export let name = 'Website name'

  // events from Popup and BuyButton toggle the modal
  function toggleModal() {
    if ($showModal === false) {
      // if modal is inactive, stores scroll pos before showing
      document.body.style.position = 'fixed'
      document.body.style.overflowY = 'hidden'
      posBeforeBuy.set($y)
    } else {
      // set scroll trigger before hiding modal
      document.body.style.position = ''
      document.body.style.overflowY = ''
      close()
    }
    showModal.set(!$showModal)
  }

  // show/hide labels
  function toggleLabels() {
    hideLabels.set(!$hideLabels)
  }

  function mainAction() {
    if ($showModal === true) {
      toggleModal()
    }
    if ($showLabelPage) {
      closeLabels()
    } else if ($showSpecimenPage) {
      closeSpecimens()
    } else {
      window.scrollTo(0, 0)
    }
  }
</script>

<nav>
  <div class="nav-wrapper">
    <h1><a on:click={mainAction}>{name}</a></h1>
    <p
      class="toggle-labels"
      class:hide={$showModal || $showLabelPage || $showSpecimenPage}
      class:active={$hideLabels}
      on:click={toggleLabels}>
      Shop Signs
    </p>
    <BuyButton on:toggle={toggleModal} />
  </div>
</nav>

{#if $showModal}
  <Popup on:close={toggleModal}>
    <Header title={BUY.title} />
    <ul>
      {#each BUY.content.item_list as item, i}
        <li><a href={item.path}><span>{i + 1}</span> {item.name}</a></li>
      {/each}
    </ul>
  </Popup>
{/if}

<style lang="scss">
  @import '../responsive.scss';

  nav {
    width: 100vw;
    height: 60px;
    background-color: var(--light);
    position: fixed;
    padding: 0 3em 0 3em;
    z-index: 5;
    .nav-wrapper {
      display: flex;
      max-width: 2000px;
      margin: auto;
    }

    @include for-phone {
      height: 40px;
      padding: 0 1em 0 1em;
    }
  }

  h1 {
    flex-grow: 4;
    margin-top: 4px;
    a {
      font-family: 'Arteria-Bold';
      color: var(--dark);
      font-size: 3rem;
      &:hover {
        cursor: pointer;
        color: var(--red);
      }
    }

    @include for-phone {
      a {
        font-size: 2rem;
      }
    }
  }

  .toggle-labels {
    flex-grow: 1;
    margin-top: 4px;
    font-family: 'Arteria-Regular';
    font-size: 3rem;
    color: var(--dark);
    cursor: pointer;
    &::before {
      content: 'O ';
      font-feature-settings: 'ss11' 1, 'ornm' 1;
      color: var(--red);
    }
    &:hover {
      color: var(--red);
    }
    &.active::before {
      font-feature-settings: 'ss11' 0, 'ornm' 1;
    }

    @include for-phone {
      font-size: 2rem;
    }
  }

  .hide {
    display: none;
    visibility: none;
  }

  ul {
    font-family: 'Arteria-Regular';
    font-size: 6em;
    margin-top: 40px;
    li a {
      cursor: pointer;
      color: var(--dark);
      &:hover {
        color: var(--red);
      }
      span {
        font-feature-settings: 'ornm' 1;
        color: var(--red);
      }
    }

    @include for-tablet {
      font-size: 4rem;
    }

    @include for-phone {
      font-size: 3rem;
    }
  }
</style>
